import { calculateColor } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, DEFAULT_COLORS_NPS, GENERAL_INDICATORS, getOxxoBloque, getOxxoBloqueGauges, OXXO_COLORS_CONFIG_BAR, OXXO_COLORS_CONFIG_SCALE_5, OXXO_COLORS_STACKED_BAR, OXXO_DEFAULT_SCALE_3_COLORS, OXXO_SCALE_3_COLORS } from '../commonWidgetsOxxoRetail'
import { List } from 'immutable';
import Immutable from 'seamless-immutable'

const CLIENT_PROFILE_LABELS = {
    1: 'Clara y Chente',
    2: 'Mila',
    3: 'Yonny y Yolanda',
    4: 'Esperanza y Lucho',
    5: 'Homero',
    6: 'Amanda',
    7: 'Chelis y Rolo',
    8: 'Otro',
};
const TABLE_QUESTIONS = [
    'oxxo_retail_rest_contrar_prod',
    'oxxo_retail_rest_condiciones',
    'oxxo_retail_gusto_prod_acomodados',
    'oxxo_retail_gusto_variedad_prod',
    'oxxo_retail_gusto_serv_facilidad',
    'oxxo_retail_serv_confianza',
    'oxxo_retail_serv_personal',
    'oxxo_retail_reunion_presentacion',
    'oxxo_retail_reunion_facilidad_compra',
    'oxxo_retail_hambre_sabor',
    'oxxo_retail_hambre_complementos',
    'oxxo_retail_hambre_condiciones',
    'oxxo_retail_hogar_presentaciones',
    'oxxo_retail_hogar_condiciones',
]

const TABLE_QUESTIONS_GROUPS: Record<string, string[]> = {  
    'RESTAURACION_PERSONAL': [
        'oxxo_retail_rest_contrar_prod',
        'oxxo_retail_rest_condiciones',],
    'GUSTOS_ANTOJOS': [
        'oxxo_retail_gusto_prod_acomodados',
        'oxxo_retail_gusto_variedad_prod',],
    'SERVICIOS_FINANCIEROS': [      
        'oxxo_retail_gusto_serv_facilidad',
        'oxxo_retail_serv_confianza',
        'oxxo_retail_serv_personal',
        ],
    'REUNION': [
        'oxxo_retail_reunion_presentacion',
        'oxxo_retail_reunion_facilidad_compra',],
    'HAMBRE_EN_MOVIMIENTO': [
        'oxxo_retail_hambre_sabor',
        'oxxo_retail_hambre_complementos',
        'oxxo_retail_hambre_condiciones',],
    'HOGAR': [
        'oxxo_retail_hogar_presentaciones',
        'oxxo_retail_hogar_condiciones',],


  }

const formatDateMonth = (dateStr: string): string => {
    const [year, month] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, 1);
    
    const monthName = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(date);
    
    return `${year} ${monthName.charAt(0).toUpperCase() + monthName.slice(1)}`;
};

export default {
    title: 'Diagnóstico y Entendimiento',
    description: 'Análisis cualitativo y cuantitativo de la experiencia',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {


        return [

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [1, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'oxxo_retail_npm_recomienda',
                
                //criticalMomentInclude: [29],//this critical momenet id overwrits the others
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS_NPS,
                    useCurrent: 0,

                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],

                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'semicircleGeneric',
                title: 'Composición NPS',
                key: 'nps-por-mes',
                size: [1, 2],
                indicator: 'oxxo_retail_npm_recomienda',
                extraConfigs: {
                    colors: OXXO_SCALE_3_COLORS,
                    categories: ['promoters', 'passives', 'detractors'],
                    useEmojis: false
                },

            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción',
                size: [2, 2],
                indicator: 'oxxo_retail_gral_npm_satisf_tienda',
                helpText: '<p><b>Pregunta: </b><br/><br/>Pensando en tu visita de hoy, ¿Qué tan satisfecho(a) estás con tu experiencia?.</p>',


                extraConfigs: {
                    decimals: 1,
                    maxValue: 5,
                    showPercentage: false,
                    colors: OXXO_COLORS_CONFIG_SCALE_5,
                },
                historic: {
                  type: 'line',
                  formula: 'wavg-5',
                  mapper: (data: any): any => {
                      return [...data].sort((a: any, b: any) => a.group.localeCompare(b.group))
                  },
              }
            }),

            {
                title: 'Aspectos por misión de visita',
                type: 'label',
                size: [4, 1],
            },

            {
                title: 'Indicadores generales',
                helpLink: '--',
                size: [4, 2],
                config: {
                    id: 'general-indicators',
                    type: 'dataTable',
                    color: ['#CCC'],
                    enableArcLabels: true,
                    valueFormat: ' >-.0%',
                    formula: "wavg-5",
                    groupName: 'Misión',
                    decimals: 1,
                    mapper: (data: any): any => {
                        const items = Immutable.isImmutable(data)
                            ? data.asMutable()
                            : (data ?? [])

                        const values: {
                                    'group_0': string,
                                    'group_1': string,                                      
                                    groupName: string,
                                    value: number,
                                    count: number
                                  }[] = items.map((item: any) => {
                          const key = Object.keys(TABLE_QUESTIONS_GROUPS).find(k => k != null && 
                                      TABLE_QUESTIONS_GROUPS[k].includes(item.group_0)
                                    ); 
                          const desc = GENERAL_INDICATORS[key as keyof typeof GENERAL_INDICATORS] || item.group_0;

                          return {
                                  'group_0': item.group_1,
                                  'group_1': desc,                                      
                                  groupName: formatDateMonth(item.group_1),
                                  value: item.value,
                                  count: item.count,
                              }
                        }).flat(1);

                        const acc: Record<string, any> = {};
                        values.forEach((curr) => {
                          const key = curr.group_0 + curr.group_1;
                          if (!acc[key]) {
                            acc[key] = { ...curr };
                          } else {
                            acc[key].value = (acc[key].value * acc[key].count + curr.value * curr.count) / (acc[key].count + curr.count) as number;
                          }
                        });
                        const finalArray = Object.values(acc).map((item: any) => ({
                            ...item,
                            value: Math.round(item.value * 10) / 10,
                        }));

                        return finalArray.sort((a: any, b: any) => a.group_0.localeCompare(b.group_0))
                    },
                    indicators: [
                        {
                            //indicator: 'RESTAURACION_PERSONAL',
                            indicator: 'MERGE',
                            label: 'group',
                            value: 'value',
                            singleton: true,
                            formula: "wavg-5",
                            //grouped: 'question',
                            grouped: 'question,formattedMonth',
                            keyExtract: [
                                'count',
                                'group_1',
                                'group_0',
                                'value',
                                'groupId_0',
                                'groupName',
                            ],
                            extras: {
                                //periods: 10,
                                groupNameFormat: "name",
                                indicators: TABLE_QUESTIONS.join(",")
                            }
                        }
                    ]
                }
            },
            {
                title: 'Detalle por misión · Satisfacción por aspecto',
                type: 'label',
                size: [4, 1],
                style: {
                    marginBottom: '0px',
                    paddingBottom: '0px',
                },
            },

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'restauracionPersonal',
                size: [1, 2],
                title: 'Restauración personal',
                subtitle: 'Bebidas y/o productos para quitar la sed, hidratarte, rendir mejor, para activarte, concentrarte o relajarte.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>¿Qué tan probable es que recomiendes a familiares o amigos esta tienda OXXO? (Escala 0-10).</p><hr/><p><b>Cómo se calcula:</b><br/><br/>NPS = %Promotores (9-10) − %Detractores (0-6). Los Pasivos (7-8) no se cuentan.</p><hr/><p><b>Qué significa:</b><br/><br/>Indicador único de lealtad. Va de -100 a +100. Mientras más alto, mejor.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Dona central con el NPS acumulado del año.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Bebidas y/o productos para quitar la sed, hidratarte, rendir mejor , para activarte, concentrarte o relajarte. (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',
                indicator: 'RESTAURACION_PERSONAL',
                indicators: [
                    {
                        title: 'Facilidad para encontrar el producto (bebida o alimento) que buscabas',
                        helpText: 'Facilidad para encontrar el producto (bebida o alimento) que buscabas',
                        indicator: 'oxxo_retail_rest_contrar_prod'
                    },
                    {
                        title: 'Condiciones (temperatura de los productos, empaque, frescura)',
                        helpText: 'Condiciones (temperatura de los productos, empaque, frescura)',
                        indicator: 'oxxo_retail_rest_condiciones'
                    },
                ]
            }),

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'gustosAntojos',
                size: [1, 2],
                title: 'Gustos y antojos',
                subtitle: 'Productos y/o bebidas para un antojo tuyo o de alguien más.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos de la misión Gustos y antojos (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Productos y/o bebidas para un antojo tuyo o de alguien más. (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',
                indicator: 'GUSTOS_ANTOJOS',
                indicators: [
                    {
                        title: 'La forma en que estaban acomodados los productos',
                        helpText: 'La forma en que estaban acomodados los productos',
                        indicator: 'oxxo_retail_gusto_prod_acomodados'
                    },
                    {
                        title: 'Variedad de productos para satisfacer tu antojo',
                        helpText: 'Variedad de productos para satisfacer tu antojo',
                        indicator: 'oxxo_retail_gusto_variedad_prod'
                    },
                ]
            }),

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'serviciosFinancieros',
                size: [1, 2],
                title: 'Servicios financieros / digitales',
                subtitle: 'Recargas telefónicas, Retiros o depósitos de dinero o pago de algún servicio.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos de la misión Servicios financieros / digitales (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Recargas telefónicas, Retiros o depósitos de dinero o pago de algún servicio. (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',

                indicator: 'SERVICIOS_FINANCIEROS',
                indicators: [
                    {
                        title: 'Facilidad y claridad para realizar tu servicio',
                        helpText: 'Facilidad y claridad para realizar tu servicio',
                        indicator: 'oxxo_retail_gusto_serv_facilidad'
                    },
                    {
                        title: 'Confianza para realizar este servicio en OXXO',
                        helpText: 'Confianza para realizar este servicio en OXXO',
                        indicator: 'oxxo_retail_serv_confianza'
                    },
                    {
                        title: 'Personal capacitado y preparado para ayudar',
                        helpText: 'Personal capacitado y preparado para ayudar',
                        indicator: 'oxxo_retail_serv_personal'
                    },
                ]
            }),

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'reunion',
                size: [1, 2],
                title: 'Reunión',
                subtitle: 'Alimentos,bebidas o artículos para organizar o llevar a una reunión.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos de la misión Reunión (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Alimentos,bebidas o artículos para organizar o llevar a una reunión. (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',                
                indicator: 'REUNION',
                indicators: [
                    {
                        title: 'Presentaciones y tamaños adecuadas',
                        helpText: 'Presentaciones y tamaños adecuadas',
                        indicator: 'oxxo_retail_reunion_presentacion'
                    },
                    {
                        title: 'Facilidad para realizar compras para varias personas',
                        helpText: 'Facilidad para realizar compras para varias personas',
                        indicator: 'oxxo_retail_reunion_facilidad_compra'
                    },
                ]
            }),

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'serviciosFinancieros',
                size: [1, 2],
                title: 'Hambre en movimiento',
                subtitle: 'Alimentos o bebidas para un desayuno o comida rápido y práctico fuera de casa.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos de la misión Hambre en movimiento (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Alimentos o bebidas para un desayuno o comida rapido y práctico fuera de casa (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',
                indicator: 'HAMBRE_EN_MOVIMIENTO',
                indicators: [
                    {
                        title: 'Sabor y frescura del producto para consumirlo en el momento',
                        helpText: 'Sabor y frescura del producto para consumirlo en el momento',
                        indicator: 'oxxo_retail_hambre_sabor'
                    },
                    {
                        title: 'Disponibilidad de complementos disponibles',
                        helpText: 'Disponibilidad de complementos disponibles (servilletas, utensilios, salsas, etc.)',
                        indicator: 'oxxo_retail_hambre_complementos'
                    },
                    {
                        title: 'Limpieza y condiciones del área donde seleccionaste o preparaste tu alimento',
                        helpText: 'Limpieza y condiciones del área donde seleccionaste o preparaste tu alimento',
                        indicator: 'oxxo_retail_hambre_condiciones'
                    },
                ]
            }),

            ...getOxxoBloque({
                mainOnLeft: true,
                id: 'hogar',
                size: [1, 2],
                title: 'Hogar',
                subtitle: 'Compras cotidianas de productos para el cuidado del hogar, higiene personal, farmacia, preservativos y cuidado del bebé y mascotas.',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos de la misión Hogar (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Compras cotidianas de productos para el cuidado del hogar, higiene personal, farmacia, preservativos y cuidado del bebé y mascotas. (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: se toman las respuestas de cada aspecto y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho).</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto de la misión, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El número mostrado al centro representa la calificación promedio de satisfacción en una escala de 1 a 5. Cuanto más cercano esté el valor a 5, mayor será el nivel de satisfacción.</p>',
                indicator: 'HOGAR',
                indicators: [
                    {
                        title: 'Presentaciones disponibles de los productos',
                        helpText: 'Presentaciones disponibles de los productos (tamaños, formatos, opciones)',
                        indicator: 'oxxo_retail_hogar_presentaciones'
                    },
                    {
                        title: 'Condiciones adecuadas de los productos que compraste',
                        helpText: 'Condiciones adecuadas de los productos que compraste (estado, limpieza, caducidad, empaque)',
                        indicator: 'oxxo_retail_hogar_condiciones'
                    },
                ]
            }),

            {
                title: 'NPS General · Tasa de respuesta · Mix de misiones',
                type: 'label',
                size: [4, 1]
            },


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Cuál fue la principal razón por la que visitaste?',
                size: [4, 3],
                indicator: 'oxxo_retail_razon_visita',
                //criticalMomentInclude: [1],
                mapper: (data: any) => {
                    //console.log('Mapper misión principal de la visita')
                    //console.log(data)
                    const mapLables: {[key: number]: string} = {
                        //1: 'Restauración personal',
                        //2: 'Gustos y Antojos',
                        //3: 'Servicios (financieros o digitales)',
                        //4: 'Reunión',
                        //5: 'Hambre en movimiento',
                        //6: 'Hogar',
                        //7: 'Otros'
                        
                        1: 'Bebidas y/o productos para quitar la sed, hidratarte, rendir mejor, para activarte, concentrarte o relajarte.',
                        2: 'Productos y/o bebidas para un antojo tuyo o de alguien más.',
                        3: 'Recargas telefónicas, Retiros o depósitos de dinero o pago de algún servicio.',
                        4: 'Alimentos, bebidas o artículos para organizar o llevar a una reunión.',
                        5: 'Alimentos o bebidas para un desayuno o comida rapido y práctico fuera de casa',
                        6: 'Compras cotidianas de productos para el cuidado del hogar, higiene personal, farmacia, preservativos y cuidado del bebé y mascotas.',
                        7: 'Otro. Especificar pregunta abierta.'                    };
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                        label: mapLables[item.groupId],
                        //groupName: item.groupId,//DEFAULT_GROUP_LABELS[item.groupId] || item.groupName
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS_NPS,
                }
            }),


            {
                title: 'Satisfacción por aspectos de los bloques opcionales',
                type: 'label',
                size: [4, 1],
            },

            ...getOxxoBloqueGauges({
                mainOnLeft: true,
                id: 'facilidadRapidezCondiciones',
                size: [1, 2],
                title: 'Facilidad, rapidez y condiciones',
                subtitle: 'Cómo encontrar productos, condiciones tienda, fila/cobro',
                helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos del bloque Facilidad, rapidez y condiciones (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                indicator: 'FACILIDAD_RAPIDEZ_CONDICIONES',
                indicators: [
                    {
                        title: 'La facilidad para encontrar y llevarte los productos que necesitabas',
                        helpText: 'Con base a esta visita, ¿Qué tan satisfecho(a) estás con los siguientes aspectos?',
                        indicator: 'oxxo_retail_bloq_facil_encont'
                    },
                    {
                        title: 'Las condiciones con las que encontraste la tienda (limpieza, olor, temperatura)',
                        helpText: 'Con base a esta visita, ¿Qué tan satisfecho(a) estás con los siguientes aspectos?',
                        indicator: 'oxxo_retail_bloq_facil_condiciones'
                    },
                    {
                        title: '¿Cómo calificas la rapidez del proceso de fila y cobro?',
                        helpText: 'Con base a esta visita, ¿Qué tan satisfecho(a) estás con los siguientes aspectos?',
                        indicator: 'oxxo_retail_bloq_facil_rapidez'
                    },
                ]
            }),


            ...getOxxoBloqueGauges({
                mainOnLeft: true,
                id: 'atencionServicio',
                title: 'Atención y servicio',
                subtitle: 'Trato del personal, imagen, profesionalismo',
                helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos del bloque Atención y servicio (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                indicator: 'ATENCION_SERVICIO',
                indicators: [
                    {
                        title: 'Atención del personal durante tu visita (trato y profesionalismo)',
                        helpText: 'Atención del personal durante tu visita (trato y profesionalismo)',
                        indicator: 'oxxo_retail_bloq_aten_personal'
                    },
                    {
                        title: 'Imagen de los empleados (uniforme e higiene)',
                        helpText: 'Imagen de los empleados (uniforme e higiene)',
                        indicator: 'oxxo_retail_bloq_aten_img_empleados'
                    },
                ]
            }),


            ...getOxxoBloqueGauges({
                mainOnLeft: true,
                id: 'productosPreciosPromociones',
                size: [1, 2],
                title: 'Productos, precios y promociones',
                subtitle: 'Variedad y precios de productos',
                //helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos del bloque Productos, precios y promociones (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por misión: el gauge muestra la distribución de las respuestas en los 5 niveles.</p><hr/><p><b>Qué significa:</b><br/><br/>Es satisfacción, NO es NPS. Permite ver el detalle granular de cada aspecto y dónde están los puntos de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Gauge a la izquierda con NS general grande al centro. Color rojo = insatisfechos, verde = satisfechos.</p>',
                helpText: '<p><b>Pregunta: </b><br/><br/>Aspectos específicos del bloque Productos, precios y promociones (escala 1-5: Muy insat / Insat / Neutral / Satisf / Muy satisf)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Por bloque: se toman las respuestas de cada pregunta y se distribuyen en los 5 niveles de satisfacción. El número central representa el porcentaje de respuestas satisfechas (Satisfecho + Muy satisfecho) de esa pregunta específica.</p><hr/><p><b>Qué significa:</b><br/><br/>Mide el nivel de satisfacción específico de cada aspecto del aspecto, no es NPS. Permite identificar con precisión en qué puntos hay oportunidades de mejora.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>El arco muestra la distribución de respuestas por color: del rojo (Muy insatisfecho) al verde oscuro (Muy satisfecho). El número central es el score del aspecto. Cuanto más cargado hacia el verde, mayor satisfacción.</p>',
                indicator: 'PRODUCTOS_PRECIOS_PROMOCIONES',
                indicators: [
                    {
                        title: 'La variedad de productos, marcas y presentaciones disponibles.',
                        helpText: 'La variedad de productos, marcas y presentaciones disponibles.',
                        indicator: 'oxxo_retail_bloq_prod_variedad'
                    },
                    {
                        title: 'Las condiciones en las que se encuentran los productos.',
                        helpText: 'Las condiciones en las que se encuentran los productos.',
                        indicator: 'oxxo_retail_bloq_prod_cond'
                    },
                    {
                        title: 'Las promociones atractivas y visibles.',
                        helpText: 'Las promociones atractivas y visibles.',
                        indicator: 'oxxo_retail_bloq_prod_promo'
                    },
                    {
                        title: 'Precios de los productos que compraste o de las comisiones de los servicios que realizaste en esta visita.',
                        helpText: 'Precios de los productos que compraste o de las comisiones de los servicios que realizaste en esta visita.',
                        indicator: 'oxxo_retail_bloq_precio'
                    }
                ],
            }),

            {
                title: 'Análisis de sentimiento + Word cloud vinculados',
                type: 'label',
                size: [4, 1],
            },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                size: [4, 5],
                indicator: 'sentiment',
                //criticalMomentInclude: [1],
                extraConfigs:   {
                    colors: OXXO_DEFAULT_SCALE_3_COLORS, 
                    typeColumn: 'percent', 
                    widgetTitle: 'Análisis de sentimientos', //top 6
                    groupKeys: ['positive', 'neutral', 'negative'],
                    groupLabels: {'positive': 'Positivos', 'neutral': 'Neutros', 'negative': 'Negativos'},
                    defaultHeight: 600,
                },

                
                mapper: (data: any, extra?: any) => {
                    //console.log('Mapper análisis de sentimiento')
                    let categories = data.categories || [];
                    //console.log(categories)
                    let sortedCategories = [...categories].sort((a: any, b: any) => a.count - b.count);//.reverse().slice(0, 6);

                    const splitTags = (item: any[]): any[] => {
                        const tags = [...(item || [])].sort((a: any, b: any) => a.count - b.count);//.reverse().slice(0, 6);
                        
                        const aux = tags.map((tag: any) => ({
                            ...tag,
                            tags: splitTags(tag.tags),
                        }));

                        return aux;
                    };
                    sortedCategories = sortedCategories.map((item: any) => ({
                        ...item,
                        tags: splitTags(item.tags),
                    }));

                    //console.log(sortedCategories)
                    return {
                      ...data,
                      categories: List(sortedCategories),
                    }
                },
            }),
           

            {
                title: 'Diagrama de Ishikawa',
                type: 'label',
                size: [4, 1],
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'diagramaIshikawa',
                //title: 'Diagrama Ishikawa',
                size: [4, 2],
                indicator: 'sentiment',
                criticalMomentInclude: [113901], //Se agrega para quitar Ad HOC
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                title: 'Comentarios recientes · pregunta de satisfacción',
                size: [4, 3],
                indicator: 'oxxo_retail_gral_comment',
                helpText: '<p><b>Pregunta: </b><br/><br/>¿Cuál fue el principal motivo de tu calificación? (todos los niveles, no solo insatisfechos)</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Listado de los últimos comentarios recientes de P2 (positivos, neutros y negativos). Ordenados por fecha desc.</p><hr/><p><b>Qué significa:</b><br/><br/>Permite ver textualmente lo que dicen los clientes, sin filtrar el tono.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Cada fila: texto del comentario + fecha + nivel de satisfacción (Sat 1-5).</p>',
                extraConfigs: {
                    maxCommentSize: 120,
                    layout: 'card',
                    showScoreBadge: true,
                    scoreColors: OXXO_COLORS_STACKED_BAR,
                    geolocationLabelShow: true,
                }
            }),


            {
                title: 'Perfil del cliente y NPS por perfil',
                type: 'label',
                size: [4, 1],
            },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Distribución por perfil de cliente',
                size: [4, 3],
                helpText: '<p><b>Pregunta: </b><br/><br/>¿Con cuál descripción te identificas más?</p><hr/><p><b>Cómo se calcula:</b><br/><br/>Las 8 categorías de la pregunta se mapean a 7 perfiles del estudio OXXO + Hibrids (Clara y Chente, Mila, etc.) + Otro. % = COUNT por perfil / COUNT total.</p><hr/><p><b>Qué significa:</b><br/><br/>Identifica qué tipo de clientes están visitando las tiendas — útil para segmentación.</p><hr/><p><b>Cómo leer la gráfica:</b><br/><br/>Dona con 8 segmentos. % visible dentro de cada gajo. Leyenda lateral con los nombres del PPT.</p>',
                indicator: 'oxxo_retail_prog_spin_te_identifica',
                extraConfigs: {
                    itemGap: 6,
                    center: ['27%', '55%'],
                    radius: [30, 100],
                },
                //criticalMomentInclude: [1],
                mapper: (data: any) => {
                    //console.log('Mapper misión principal de la visita')
                    //console.log(data)
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                        label: CLIENT_PROFILE_LABELS[item.groupId],
                        //label: item.group,
                        //groupName: item.groupId,//DEFAULT_GROUP_LABELS[item.groupId] || item.groupName
                    }))
                },
            }),
            

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                //name: 'stackedBar',
                title: 'Distribución por perfil de cliente',
                size: [4, 3],
                indicator: 'oxxo_retail_npm_recomienda',
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 13708,
                    groupBy: "responseValue",
                },
                 extraConfigs: {
                    colors: OXXO_DEFAULT_SCALE_3_COLORS,
                    groupKeys: ['promoters', 'passives', 'detractors'],
                    groupLabels: {'promoters': 'Promotores', 'passives': 'Neutros', 'detractors': 'Detractores'},
                    decimals: 0,

                    tooltipExpander: (items: any, html: string) => {
                        const promoter = items.find((item: any) => item.seriesName == 'Promotores')?.value;
                        const detractor = items.find((item: any) => item.seriesName == 'Detractores')?.value;
                        
                        if (promoter == null && detractor == null) {
                            return html;
                        }
                        const nps = (promoter??0) - (detractor??0);
                        const color = calculateColor({ 
                            colors: OXXO_COLORS_CONFIG_BAR,
                            groupKey: "",
                            idx: 111,
                            value: nps
                        });
                        const tooltip = html + `<br/> 
                                <span style="
                                display:inline-block;
                                width:100%;
                                margin-right:6px;
                                text-align: center;
                                color: ${color};
                                border-top: 1px solid ${color};
                                border-bottom: 1px solid ${color};
                                ">
                                NPS: <b>${Number(nps).toFixed(0)}</b><br/>
                            </span>`;
                        return tooltip;
                    },
                 },
                
                mapper: (data: any) => {
                    //console.log('Mapper misión principal de la visita - Barra')
                    //console.log(data)

                    var values = data
                      .filter((item: any) => {
                        const key = item.groupId_1 ?? item.groupId;
                        return key && key in CLIENT_PROFILE_LABELS;
                      })
                    .map((item: any) => {
                      return {
                        ...item,
                        //groupName: CLIENT_PROFILE_LABELS[item.groupId] || item.group,
                        group: CLIENT_PROFILE_LABELS[ item.groupId_1 ?? item.groupId], 
                        groupName: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],
                        label: CLIENT_PROFILE_LABELS[item.groupId_1 ?? item.groupId],
                      }
                    });//.flat(1);
                    //console.log('Antes de reducir');
                    //console.log(values);
                    var initialValues: any = [];
                    values = values.reduce((acc: any, curr: any) => {
                        const existingGroup = acc.find((item: any) =>
                          (item.groupId_1 ?? item.groupId) === (curr.groupId_1 ?? curr.groupId)
                        );
                        
                      if (existingGroup) {
                        existingGroup.count += curr.count;
                        existingGroup.detractorCount += curr.detractorCount;
                        existingGroup.passiveCount += curr.passiveCount;
                        existingGroup.promoterCount += curr.promoterCount;
                        existingGroup.value += curr.value;
                      } else {
                        acc.push({ ...curr });
                      } 
                      return acc;
                    }, initialValues)
                    .toSorted((a: any, b: any) => 
                      b.promoterCount - a.promoterCount || 
                      b.passiveCount - a.passiveCount || 
                      b.detractorCount - a.detractorCount
                    );


                    //console.log(values)
                    return values
                },
            }),

        ]
    },
} as DasboardConfig
